// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Movue from 'movue'
import * as mobx from 'mobx'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import stores from './stores'
import kit from './common/kit'
import App from './App'
import router from './router'
import VCharts from 'v-charts'
import locale from 'element-ui/lib/locale/lang/en'
//import './styles/global.scss'

(async () => {
  // 首先执行 stores 中的 init 中的方法,这是一个同步等待的方法
  for (var key in stores) {
    if (stores[key].init) {
      await stores[key].init()
    }
  }
  Vue.config.productionTip = false
  Vue.prototype.$kit = kit // 将 kit 工具类绑定成全局
  Vue.prototype.$toJS = mobx.toJS // 将 mobx 的数据类型转换为 JavaScript 的类型,绑定为全局

  Vue.use(ElementUI, {locale})
  Vue.use(Movue, mobx)
  Vue.use(VCharts)
  Vue.component('icon', Icon)

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
  })
})()



// WEBPACK FOOTER //
// ./src/main.js